<template>
  <Tippy
    ref="popover"
    trigger="click"
    interactive
    theme="light"
    max-width="600"
    placement="bottom"
  >
    <template #trigger>
      <div class="sort-option-selected">
        <div
          class="font-weight-bold text-secondary"
          style="font-size: 10px; min-width: 120px"
        >
          {{ label }}
        </div>
        <div
          style="font-size: 14px"
          class="text-truncate"
        >
          {{ selectedText }}
        </div>
      </div>
    </template>

    <div class="dropdown-scroll">
      <div
        class="sort-option text-left first"
        :class="{ active: !selected }"
        @click="select('')"
      >
        {{ allLabel }}
      </div>
      <div
        v-for="option in options"
        :key="option.value"
        class="sort-option text-left"
        :class="{ active: selected === option.value }"
        @click="select(option.value)"
      >
        {{ option.text }}
      </div>
    </div>
  </Tippy>
</template>

<script>
export default {
  props: {
    label: String,
    allLabel: String,
    selected: String,
    options: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectedText() {
      const found = this.options.find((x) => x.value === this.selected);
      return found ? found.text : this.allLabel;
    },
  },
  methods: {
    select(value) {
      this.$emit('update:selected', value);
      this.$refs.popover.tippy().hide();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/components/reports/small-filter.scss';

.sort-option-selected {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: auto;
  min-height: 44px;
}
</style>
